'use strict';

var React = require('react');

var SvgBalanceMajor = function SvgBalanceMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 1c-.493 0-1.211.14-1.834.588-.674.486-1.166 1.286-1.166 2.412v13.5a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-2.5h-3c-.493 0-1.211-.14-1.834-.588-.676-.487-1.166-1.286-1.166-2.412s.492-1.926 1.166-2.412a3.233 3.233 0 0 1 1.834-.588h3v-2.5c0-.824-.665-1.5-1.498-1.5h-.502v-2.5a1.5 1.5 0 0 0-1.5-1.5h-11.5zm12 10h3v2h-3c-.173 0-.456-.06-.666-.211-.159-.115-.334-.315-.334-.789 0-.474.175-.674.334-.789.21-.15.493-.211.666-.211zm-12-8a1 1 0 0 0-1 1v1h12v-2h-11z"
  }));
};

exports.SvgBalanceMajor = SvgBalanceMajor;
